"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sleep = exports.setlocalStorage = exports.saveLocalStorage = exports.removelocalStorage = exports.monitorLog = exports.isObject = exports.guid = exports.getlocalStorage = exports.getWechatVerison = exports.getWebLoadTimeInfo = exports.getQueryString = exports.getOsVersion = exports.getNetworkMsg = exports.getNetworkInfo = exports.getLogType = exports.getConsumerId = exports.getAppIdForH5 = exports.getAppClient = exports.format = exports.deepClone = exports.appUa = void 0;

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.regexp.constructor.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.string.search.js");

require("core-js/modules/es.array.concat.js");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 获取appUa
 */
var appUa = function appUa() {
  var appua = navigator.userAgent; // app的UserAgent信息

  if (appua && appua.indexOf('{"appVersion') !== -1) {
    return JSON.parse(appua.substring(appua.indexOf('{')));
  }

  return {};
};
/**
 *  获取唯一id 
 */


exports.appUa = appUa;

var guid = function guid() {
  var appua = appUa();
  if (appua.user_id) return appua.user_id;

  if (localStorage && localStorage.getItem('guid')) {
    return localStorage.getItem('guid');
  }

  var guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });

  if (localStorage) {
    localStorage.setItem('guid', guid);
  }

  return guid;
};
/**
 *  获取 consumerId 
 */


exports.guid = guid;

var getConsumerId = function getConsumerId() {
  var appua = appUa();
  if (appua.consumerId) return appua.consumerId;
  return '';
};
/**
 * 睡眠
 * @param {*} timer 
 */


exports.getConsumerId = getConsumerId;

var sleep = function sleep(timer) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, timer);
  });
};
/**
 * 对象拷贝
 * @param {*} obj 
 */


exports.sleep = sleep;

var deepClone = function deepClone(obj) {
  if (obj === null) return null;

  var clone = _objectSpread({}, obj);

  Object.keys(clone).forEach(function (key) {
    clone[key] = _typeof(obj[key]) === 'object' ? deepClone(obj[key]) : obj[key];
  });
  var oclone = Array.isArray(obj) ? Array.from(obj) : clone;
  var newobj = Array.isArray(obj) && obj.length ? (clone.length = obj.length) && Array.from(clone) : oclone;
  return newobj;
};
/**
 * 获取url参数
 * @param {*} name 
 */


exports.deepClone = deepClone;

var getQueryString = function getQueryString(name) {
  var reg = new RegExp("(^|&)".concat(name, "=([^&]*)(&|$)"), 'i');
  var r = window.location.search.substr(1).match(reg);

  if (r != null) {
    return unescape(r[2]);
  }

  return null;
};
/**
   * 获取os信息
   */


exports.getQueryString = getQueryString;

var getOsVersion = function getOsVersion() {
  var u = navigator.userAgent;
  var version = '';

  if (u.indexOf('Mac OS X') > -1) {
    // ios
    var regStrSaf = /OS [\d._]*/gi;
    var verinfo = u.match(regStrSaf);
    version = "IOS".concat(verinfo.toString().replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.'));
  } else if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    // android
    version = "Android".concat(u.substr(u.indexOf('Android') + 8, u.indexOf(';', u.indexOf('Android')) - u.indexOf('Android') - 8));
  } else if (u.indexOf('BB10') > -1) {
    // 黑莓bb10系统
    version = "blackberry".concat(u.substr(u.indexOf('BB10') + 5, u.indexOf(';', u.indexOf('BB10')) - u.indexOf('BB10') - 5));
  } else if (u.indexOf('IEMobile') > -1) {
    // windows phone
    version = "winphone".concat(u.substr(u.indexOf('IEMobile') + 9, u.indexOf(';', u.indexOf('IEMobile')) - u.indexOf('IEMobile') - 9));
  } else {
    var userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.indexOf('windows nt 5.0') > -1) {
      version = 'Windows 2000';
    } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
      version = 'Windows XP';
    } else if (userAgent.indexOf('windows nt 6.0') > -1) {
      version = 'Windows Vista';
    } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
      version = 'Windows 7';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
      version = 'Windows 8';
    } else if (userAgent.indexOf('windows nt 6.3') > -1) {
      version = 'Windows 8.1';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
      version = 'Windows 10';
    } else {
      version = 'Unknown';
    }
  }

  return version;
};
/**
 * 是不是微信中
 */


exports.getOsVersion = getOsVersion;

var isWeiXin = function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();

  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  }

  return false;
};
/**
 * 获取appClient
 */


var getAppClient = function getAppClient() {
  if (appUa().appClient) {
    var ua = appUa().appClient;
    if (ua === 'ios') return 'iOS-h5';
    if (ua === 'android') return 'Android-h5';
  }

  if (isWeiXin()) return 'wechat';
  return 'h5';
};
/**
 * 获取微信版本号
 */


exports.getAppClient = getAppClient;

var getWechatVerison = function getWechatVerison() {
  if (isWeiXin()) {
    var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
    return wechatInfo[1];
  }

  return '';
};
/**
 * 获取getAppIdForH5
 */


exports.getWechatVerison = getWechatVerison;

var getAppIdForH5 = function getAppIdForH5() {
  if (appUa().appIdForH5) return appUa().appIdForH5;
  return '';
};
/**
 * isObject
 * @param {*} obj 
 */


exports.getAppIdForH5 = getAppIdForH5;

var isObject = function isObject(obj) {
  return obj === Object(obj);
};
/**
 * 插入存储数据
 */


exports.isObject = isObject;

var setlocalStorage = function setlocalStorage(key, value) {
  if ((typeof localStorage === "undefined" ? "undefined" : _typeof(localStorage)) !== 'object') return false;
  if (!isObject(value)) return false;
  var localData = localStorage.getItem(key) || '[]';
  var data = JSON.parse(localData);
  data.push(value);
  localStorage.setItem(key, JSON.stringify(data));
  return true;
};
/**
 * 直接存储
 * @param {*} key 
 * @param {*} value 
 */


exports.setlocalStorage = setlocalStorage;

var saveLocalStorage = function saveLocalStorage(key, value) {
  if (!localStorage) return false;
  var val = value;

  if (val !== '') {
    val = JSON.stringify(value);
  }

  localStorage.setItem(key, val);
  return true;
};
/**
 * 取数据
 * @param {*} key 
 */


exports.saveLocalStorage = saveLocalStorage;

var getlocalStorage = function getlocalStorage(key) {
  if (!localStorage) return false;
  if (!key) return false;
  var ar = localStorage.getItem(key);

  if (ar) {
    return JSON.parse(ar);
  }

  return false;
};
/**
 * 删除数据
 * @param {*} key 
 */


exports.getlocalStorage = getlocalStorage;

var removelocalStorage = function removelocalStorage(key) {
  if (!localStorage) return false;
  if (!key) return false;
  var ar = localStorage.getItem(key) || '[]';
  return JSON.parse(ar);
};
/**
 * 获取app传过来的性能相关的数据
 * @param {*} cb 
 */


exports.removelocalStorage = removelocalStorage;

var getWebLoadTimeInfo = function getWebLoadTimeInfo(cb) {
  // eslint-disable-next-line no-undef
  window.getWebLoadTimeInfoFc = function (obj) {
    var rObj = obj;

    if (typeof obj === 'string') {
      rObj = JSON.parse(rObj);
    } // eslint-disable-next-line no-unused-expressions


    cb && cb(rObj);
  };

  var appCont = getQueryString('appCont') || 0;
  var appContAr = ['1', '2'];
  var appua = appUa();

  if (appContAr.indexOf(appCont) > -1 && appua.appIdForH5 >= '20200108') {
    try {
      // eslint-disable-next-line eqeqeq
      if (appua.appClient == 'ios' && appua.useWkWeb == 1) {
        window.webkit.messageHandlers.getWebLoadTimeInfo.postMessage({
          funcName: 'getWebLoadTimeInfoFc'
        });
      }

      if (appua.appClient === 'android') {
        // eslint-disable-next-line no-undef
        yjapp.getWebLoadTimeInfo('{"funcName": "getWebLoadTimeInfoFc"}');
      }
    } catch (err) {
      cb(false);
    }
  } else {
    cb(false);
  }
};
/**
 * 获取网络信息
 */


exports.getWebLoadTimeInfo = getWebLoadTimeInfo;

var getNetworkInfo = function getNetworkInfo() {
  try {
    var c = navigator.connection;
    if (!c) return {};
    return {
      downlink: c.downlink,
      effectiveType: c.effectiveType
    };
  } catch (err) {
    return {};
  }
};
/**
 * 获取当前网络下载速率，该api存在兼容问题 
 */


exports.getNetworkInfo = getNetworkInfo;

var getNetworkMsg = function getNetworkMsg() {
  var o = getNetworkInfo();
  if (Object.keys(o).length !== 2) return '';
  return "".concat(o.downlink, "Mb/s,").concat(o.effectiveType);
};
/**
 * 调用app方法
 */


exports.getNetworkMsg = getNetworkMsg;

var monitorLog = function monitorLog(type, msg) {
  // app支持有则调用，无则跳过
  if (typeof yjapp != "undefined" && typeof yjapp['monitorLog'] == 'function') {
    // 与安卓app通讯方式
    yjapp['monitorLog'](type, JSON.stringify(msg));
  } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers['monitorLog']) {
    // 与iOS app通讯方式
    // window.webkit.messageHandlers['monitorLog'].postMessage(type,JSON.stringify(msg))
    window.webkit.messageHandlers['monitorLog'].postMessage({
      'type': type,
      'msg': JSON.stringify(msg)
    });
  }
};
/**
  * 转换时间格式
  * 用法：format(ms,'yyyy-MM-dd hh:mm:ss')
  * @param time 毫秒数
  * @param fmt 要转换的时间格式
  */


exports.monitorLog = monitorLog;

var format = function format(time, fmt) {
  var d = new Date(time + 8 * 3600 * 1000);
  var o = {
    'M+': d.getUTCMonth() + 1,
    //月份
    'd+': d.getUTCDate(),
    //日
    'h+': d.getUTCHours(),
    //小时
    'm+': d.getUTCMinutes(),
    //分
    's+': d.getUTCSeconds(),
    //秒
    'q+': Math.floor((d.getUTCMonth() + 3) / 3),
    //季度
    S: d.getUTCMilliseconds() //毫秒

  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getUTCFullYear() + '').substr(4 - RegExp.$1.length));

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  }

  return fmt;
};
/**
 * 传入app的格式
 */


exports.format = format;

var getLogType = function getLogType() {
  var logType = ['h5_error_js', // js错误
  'h5_error_vue', // vue错误
  'h5_network_log', // 网络调试日志
  'h5_network_error', // 日志错误
  'h5_network_notzero', // 日志信息
  'h5_log_debug', // 日志调试日志
  'h5_performance_log', // 性能
  'h5_abnormal_log' // 异常日志
  ];
  return logType;
};

exports.getLogType = getLogType;